<template>
  <div
    class="relative"
  >
    <button
      v-if="media.length > 1"
      class="absolute left-2 bottom-1/2 border border-black rounded-full w-8 h-8 flex justify-center items-center hover:bg-gray-100 active:bg-gray-200 z-10 bg-white"
      type="button"
      @click="mediaSwiper?.slidePrev()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
  <path fill-rule="evenodd" d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z" clip-rule="evenodd" />
</svg>
    </button>

    <Swiper
      class="max-w-sm"
      :space-between="20"
      :loop="media.length > 1"
      centered-slides
      :modules="[Pagination]"
      :pagination="{
        el: `.swiper-pagination-contract-event-media`,
        type: 'bullets'
      }"
      @swiper="setSwiper"
    >
      <SwiperSlide
        v-for="item in media"
        :key="item.uuid"
        class="!h-auto"
      >
        <div class="flex items-center w-full justify-center h-full">
          <MediaDisplay
            class="max-w-60"
            :media="item"
            :allow-delete="allowDelete"
            @delete="emits('delete', $event.uuid)"
          />
        </div>
      </SwiperSlide>
    </Swiper>

    <div class="flex mx-auto w-fit mt-2">
      <div class="swiper-pagination-contract-event-media" />
    </div>

    <button
      v-if="media.length > 1"
      class="absolute right-2 bottom-1/2 border border-black rounded-full w-8 h-8 flex justify-center items-center hover:bg-gray-100 active:bg-gray-200 z-10 bg-white"
      type="button"
      @click="mediaSwiper?.slideNext()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import MediaDisplay from '@/components/MediaDisplay.vue';
import { Media } from '@/composables/useMediaCollection';
import { Pagination } from 'swiper/modules';
import type { Swiper as SwiperInterface } from 'swiper/types';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from 'vue';

const props = defineProps<{
  media: Media[];
  allowDelete?: boolean;
}>();

const emits = defineEmits<{
  (e: 'delete', uuid: string);
}>();

const mediaSwiper = ref<SwiperInterface>();

const setSwiper = (swiper: SwiperInterface) => {
  mediaSwiper.value = swiper;
};
</script>

<style scoped></style>
